<template>
  <QIcon :color="currentColor" :size="size">
    <svg width="86" height="48" viewBox="0 0 86 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.4191 34.9161C16.5187 34.9161 14.9727 36.4622 14.9727 38.3625C14.9727 40.2629 16.5187 41.8089 18.4191 41.8089C20.3194 41.8089 21.8654 40.2629 21.8654 38.3625C21.8654 36.4622 20.3194 34.9161 18.4191 34.9161ZM18.4191 39.1302C18.0003 39.1302 17.6568 38.7866 17.6568 38.3679C17.6568 37.9492 18.0003 37.6056 18.4191 37.6056C18.8378 37.6056 19.1813 37.9492 19.1813 38.3679C19.1813 38.7866 18.8378 39.1302 18.4191 39.1302Z"
        :fill="currentColor ? undefined : 'url(#icon0_linear)'"
      />
      <path
        d="M67.9353 34.9269C66.0403 34.9269 64.4996 36.4676 64.4996 38.3625C64.4996 40.2575 66.0403 41.7982 67.9353 41.7982C69.8302 41.7982 71.3709 40.2575 71.3709 38.3625C71.3709 36.4676 69.8302 34.9269 67.9353 34.9269ZM67.9353 39.1141C67.5219 39.1141 67.1837 38.7759 67.1837 38.3625C67.1837 37.9492 67.5219 37.611 67.9353 37.611C68.3486 37.611 68.6868 37.9492 68.6868 38.3625C68.6868 38.7759 68.3486 39.1141 67.9353 39.1141Z"
        :fill="currentColor ? undefined : 'url(#icon1_linear)'"
      />
      <path
        d="M82.8803 20.2449L80.0298 16.3691C79.6433 15.6497 77.0397 10.872 74.5811 7.46322C74.565 7.44174 74.5543 7.42564 74.5381 7.40417L71.7252 3.92558C70.2275 1.97692 67.8601 0.812022 65.4015 0.812022H5.08981C2.56139 0.806654 0.5 2.86804 0.5 5.39646V36.269C0.5 38.3733 2.21245 40.0857 4.31679 40.0857H6.3406C7.08141 40.0857 7.68265 39.4845 7.68265 38.7437C7.68265 38.0029 7.08141 37.4016 6.3406 37.4016H4.31679C3.68871 37.4016 3.1841 36.8917 3.1841 36.269V5.39646C3.1841 4.34429 4.03764 3.49075 5.08981 3.49075H65.4015C67.0334 3.49075 68.6009 4.26377 69.6155 5.58435L72.4285 9.06294C74.93 12.5362 77.6839 17.6735 77.7161 17.7218C77.7483 17.7755 77.7805 17.8346 77.8181 17.8829L80.7384 21.8553C80.7384 21.8553 80.7599 21.8876 80.776 21.9037C82.0912 23.5356 82.8159 25.5916 82.8159 27.6852V37.3748C82.8159 37.5251 82.6924 37.6432 82.5475 37.6432H80.2875C79.5467 37.6432 78.9454 38.2444 78.9454 38.9853C78.9454 39.7261 79.5467 40.3273 80.2875 40.3273H82.5475C84.1741 40.3273 85.5 39.0014 85.5 37.3748V27.6852C85.5 24.9904 84.5713 22.3439 82.8803 20.2449Z"
        :fill="currentColor ? undefined : 'url(#icon2_linear)'"
      />
      <path
        d="M55.7226 37.6432H30.6424C29.9016 37.6432 29.3004 38.2444 29.3004 38.9852C29.3004 39.726 29.9016 40.3273 30.6424 40.3273H55.7226C56.4634 40.3273 57.0647 39.726 57.0647 38.9852C57.0647 38.2444 56.4634 37.6432 55.7226 37.6432Z"
        :fill="currentColor ? undefined : 'url(#icon3_linear)'"
      />
      <path
        d="M18.419 29.5372C13.5501 29.5372 9.59373 33.499 9.59373 38.3625C9.59373 43.2261 13.5555 47.1879 18.419 47.1879C23.2826 47.1879 27.2444 43.2261 27.2444 38.3625C27.2444 33.499 23.2826 29.5372 18.419 29.5372ZM18.419 44.5091C15.0317 44.5091 12.2778 41.7552 12.2778 38.3679C12.2778 34.9806 15.0317 32.2267 18.419 32.2267C21.8064 32.2267 24.5603 34.9806 24.5603 38.3679C24.5603 41.7552 21.8064 44.5091 18.419 44.5091Z"
        :fill="currentColor ? undefined : 'url(#icon4_linear)'"
      />
      <path
        d="M67.9353 29.5372C63.0663 29.5372 59.11 33.499 59.11 38.3625C59.11 43.2261 63.0717 47.1879 67.9353 47.1879C72.7989 47.1879 76.7606 43.2261 76.7606 38.3625C76.7606 33.499 72.7989 29.5372 67.9353 29.5372ZM67.9353 44.5091C64.548 44.5091 61.7941 41.7552 61.7941 38.3679C61.7941 34.9806 64.548 32.2267 67.9353 32.2267C71.3226 32.2267 74.0765 34.9806 74.0765 38.3679C74.0765 41.7552 71.3226 44.5091 67.9353 44.5091Z"
        :fill="currentColor ? undefined : 'url(#icon5_linear)'"
      />
      <path
        d="M65.6753 8.85893C66.4161 8.85893 67.0173 8.25769 67.0173 7.51688C67.0173 6.77607 66.4161 6.17484 65.6753 6.17484H53.6827C52.9419 6.17484 52.3407 6.77607 52.3407 7.51688V19.3752C52.3407 20.116 52.9419 20.7173 53.6827 20.7173H64.9667L68.3057 22.9827C68.5258 23.133 68.7888 23.2135 69.0572 23.2135H75.2736C76.0144 23.2135 76.6157 22.6122 76.6157 21.8714C76.6157 21.1306 76.0144 20.5294 75.2736 20.5294H69.4652L66.1262 18.264C65.9061 18.1137 65.6431 18.0332 65.3747 18.0332H62.9912C63.0019 17.9688 63.0126 17.899 63.0126 17.8346V12.4395C63.0126 11.6987 62.4114 11.0975 61.6706 11.0975C60.9298 11.0975 60.3286 11.6987 60.3286 12.4395V17.8346C60.3286 17.9043 60.3393 17.9688 60.35 18.0332H55.0194V8.85893H65.6753Z"
        :fill="currentColor ? undefined : 'url(#icon6_linear)'"
      />
      <path
        d="M8.70794 14.3882H46.5645C47.3053 14.3882 47.9065 13.787 47.9065 13.0462C47.9065 12.3054 47.3053 11.7041 46.5645 11.7041H8.70794C7.96713 11.7041 7.36589 12.3054 7.36589 13.0462C7.36589 13.787 7.96713 14.3882 8.70794 14.3882Z"
        :fill="currentColor ? undefined : 'url(#icon7_linear)'"
      />
      <path
        d="M47.9065 22.5156C47.9065 21.7748 47.3053 21.1735 46.5645 21.1735H8.70794C7.96713 21.1735 7.36589 21.7748 7.36589 22.5156C7.36589 23.2564 7.96713 23.8576 8.70794 23.8576H46.5645C47.3053 23.8576 47.9065 23.2564 47.9065 22.5156Z"
        :fill="currentColor ? undefined : 'url(#icon8_linear)'"
      />
      <path
        d="M60.1192 25.6828C60.1192 24.942 59.5179 24.3408 58.7771 24.3408H55.1106C54.3698 24.3408 53.7686 24.942 53.7686 25.6828C53.7686 26.4237 54.3698 27.0249 55.1106 27.0249H58.7771C59.5179 27.0249 60.1192 26.4237 60.1192 25.6828Z"
        :fill="currentColor ? undefined : 'url(#icon9_linear)'"
      />
      <defs>
        <linearGradient id="icon0_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon1_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon2_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon3_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon4_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon5_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon6_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon7_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon8_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon9_linear" x1="43" y1="0.812012" x2="43" y2="47.1879" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
      </defs>
    </svg>
  </QIcon>
</template>
<script>
import { QIcon } from 'quasar';
export default {
  name: 'SedanIcon',
  props: {
    color: {
      type: String
    },
    size: {
      type: String
    }
  },
  data() {
    return {
      currentColor: this.color
    };
  },
  watch: {
    color(value) {
      this.currentColor = value;
    }
  },
  components: { QIcon }
};
</script>
